import styled from 'styled-components'
import { brandPalette as palette } from '../../styles/abstracts/_variables.styles'

export const PhotoSection = styled.section`
  border-top:1px solid var(--forecast-line); padding:2.8rem 0; margin-bottom:1rem;
  >p{font-size:1.5rem;max-width:65ch;}
`
export const PhotoReport = styled.figure`
  display:grid; grid-template-columns:minmax(0,1fr) minmax(24rem,.65fr); gap:3rem;
  align-items:center; margin:2rem 0 0; padding:2rem; border-radius:.8rem; background:${palette.chalk};
  img{display:block;width:100%;height:auto;max-height:56rem;object-fit:contain;border-radius:.4rem;}
  figcaption{font-size:1.5rem;min-width:0;}
  .report-source{text-transform:uppercase;letter-spacing:.12em;font-size:1.15rem;margin:0 0 1rem;}
  .report-time{font-size:2rem;line-height:1.5;max-width:23ch;}
  dl{margin:2rem 0;display:grid;gap:1.2rem;}
  dl>div{display:flex;justify-content:space-between;gap:2rem;border-bottom:1px solid var(--forecast-line);padding-bottom:1rem;}
  dt{font-size:1.4rem;}dd{margin:0;font-weight:600;text-align:right;}
  .report-note{font-size:1.3rem;max-width:45ch;}
  @media(max-width:767px){grid-template-columns:1fr;gap:1.8rem;padding:1.6rem;img{max-height:64rem;}dl{margin:1.5rem 0;}.report-time{max-width:none;}}
  @media(max-width:359px){padding:1.2rem;gap:1.4rem;}
`
